import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MaterialModule } from '../../../app.material.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FunctieModule } from '../../../components/functie/functie.module';
import { ContentModule } from '../../../services/content/content.module';
import { FunctieCardModule } from '../../../components/functie/card/functie-card.module';
import { ChatterModule } from '../../../components/chatter/chatter.module';
import { FunctieToekomstOpbouwPageComponent } from './functie-toekomst-opbouw-page.component';

const routes: Routes = [
  {
    path: '',
    component: FunctieToekomstOpbouwPageComponent
  }
];

@NgModule({
  declarations: [FunctieToekomstOpbouwPageComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    FunctieModule,
    FunctieCardModule,
    ContentModule,
    ChatterModule
  ],
  exports: [FunctieToekomstOpbouwPageComponent]
})
export class FunctieToekomstOpbouwPageModule {}
